export default {
  notifications: []
}
